export default {
  notifications: []
}
